import { render, staticRenderFns } from "./ModalNotSubstract.vue?vue&type=template&id=4d45e2b5&scoped=true"
import script from "./ModalNotSubstract.vue?vue&type=script&lang=js"
export * from "./ModalNotSubstract.vue?vue&type=script&lang=js"
import style0 from "./ModalNotSubstract.vue?vue&type=style&index=0&id=4d45e2b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d45e2b5",
  null
  
)

export default component.exports